import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { AbstractAggregation, AggregatedJobData } from '@shared/models';

import * as AggregationActions from './aggregations.actions';
import {
  loadTotalDirectPerPhaseSuccess,
  loadActiveJobsCountSuccess,
  loadAggregatedMatchesSuccess,
} from './aggregations.actions';

export interface CandidateAggregationsState extends EntityState<AbstractAggregation> {
  totalDirectCandidatesPerPhases?: any[];
  pipelineActiveJobsCount: number;
  pipelineAggregatedMatches: AggregatedJobData;
}

export const candidateAggregationAdapter: EntityAdapter<AbstractAggregation<any>> =
  createEntityAdapter<AbstractAggregation<any>>({
    selectId: (aggregation: AbstractAggregation<any>) => aggregation.jobId,
    sortComparer: false,
  });

export const candidateAggregationsState: CandidateAggregationsState =
  candidateAggregationAdapter.getInitialState({
    totalDirectCandidatesPerPhases: null,
    pipelineActiveJobsCount: null,
    pipelineAggregatedMatches: null,
  });

export const aggregationsReducer = createReducer(
  candidateAggregationsState,
  on(AggregationActions.AggregationLoadHiringManagerSuccess, (state, { payload }) =>
    candidateAggregationAdapter.upsertOne(payload, state),
  ),
  on(AggregationActions.LoadAggregatedJobsDataSuccess, (state, { aggregatedJobsData }) =>
    candidateAggregationAdapter.upsertMany(aggregatedJobsData, state),
  ),
  on(loadTotalDirectPerPhaseSuccess, (state, { totalDirectPerPhase }) => ({
    ...state,
    totalDirectCandidatesPerPhases: totalDirectPerPhase,
  })),
  on(loadActiveJobsCountSuccess, (state, { activeJobsCount }) => ({
    ...state,
    pipelineActiveJobsCount: activeJobsCount,
  })),
  on(loadAggregatedMatchesSuccess, (state, { aggregatedMatches }) => ({
    ...state,
    pipelineAggregatedMatches: aggregatedMatches,
  })),
);
